import * as React from "react";

const SvgIcnAgentsViewBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.007 15.213a4 4 0 014 4V20H3.978v-.787a4 4 0 014-4h8.029zM12 3a5 5 0 110 10 5 5 0 010-10z"
        />
    </svg>
);

export default SvgIcnAgentsViewBold;
